var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionPerformanceManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162_1707",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 40,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 5.41699H43.1998V43.817H4.7998V5.41699Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162_1707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8621 17.9336L5.33166 33.4232C5.15495 33.5959 5.01454 33.8021 4.91868 34.0298C4.82282 34.2575 4.77344 34.5021 4.77344 34.7492C4.77344 34.9963 4.82282 35.2408 4.91868 35.4685C5.01454 35.6963 5.15495 35.9025 5.33166 36.0752L12.4597 43.1828C13.2037 44.0312 14.3737 44.0312 15.1189 43.1828L27.3505 30.9836C24.0529 27.3764 21.8197 22.922 20.8621 17.936V17.9336Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9252 17.6162L15.1172 5.94738C14.9436 5.77105 14.7366 5.63102 14.5083 5.53543C14.2801 5.43985 14.0351 5.39063 13.7876 5.39062C13.5401 5.39062 13.2951 5.43985 13.0669 5.53543C12.8386 5.63102 12.6316 5.77105 12.458 5.94738L5.3312 13.055C5.15435 13.2276 5.01381 13.4338 4.91785 13.6615C4.82189 13.8892 4.77246 14.1339 4.77246 14.381C4.77246 14.6281 4.82189 14.8727 4.91785 15.1004C5.01381 15.3282 5.15435 15.5344 5.3312 15.707L19.7996 30.1322C20.8628 25.3586 23.4164 21.0086 26.9264 17.615L26.9252 17.6162Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6677 33.4216L28.0949 18.8896C26.4989 23.2384 23.3069 27.0568 19.3721 29.7088L32.7749 43.0744C33.6269 43.9228 34.6901 43.9228 35.4341 43.0744L42.5621 35.968C43.3061 35.332 43.3061 34.0576 42.6677 33.4216Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3913 26.9513L42.6677 15.7073C43.4117 14.9633 43.4117 13.7969 42.6677 13.0553L35.5397 5.94775C35.3661 5.7716 35.1592 5.63172 34.931 5.53624C34.7029 5.44077 34.458 5.3916 34.2107 5.3916C33.9633 5.3916 33.7185 5.44077 33.4903 5.53624C33.2622 5.63172 33.0553 5.7716 32.8817 5.94775L19.3721 19.4189C23.6553 21.4589 27.6876 23.9864 31.3913 26.9513Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9464 14.8574L14.1592 24.617L23.9452 34.3766L33.7312 24.617L23.9464 14.8574Z",
    fill: "#CED2DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9464 14.8574L14.1592 24.617L23.9452 34.3766L33.7312 24.617L23.9464 14.8574Z",
    fill: "#0A0B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9464 14.8574L14.1592 24.617L23.9452 34.3766L33.7312 24.617L23.9464 14.8574Z",
    fill: "#101114"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionPerformanceManagement);
export default __webpack_public_path__ + "static/media/transaction_performance_management.008100ebf4aba5754fe90d3553661894.svg";
export { ForwardRef as ReactComponent };